module.exports = __webpack_public_path__ + "assets/fa-brands-400.c1868c9545d2de1cf8488f1dadd8c9d0.eot";